module.exports = __webpack_public_path__ + "static/professional-help-access-b1a2968d647093986c89e32cb0dcdb0e.svg";